




































































































































































































    import {Component, Vue, Watch} from "vue-property-decorator";
    import YcHeader from "@/components/common/yc-header.vue"
    import YcAside from "@/components/common/yc-aside.vue"
    import {TFenqunDetailVO, TFenqunRecordVO, TFenqunUserInfoVO} from "@/model/TFenqunVO";
    import FlowBox from "@/components/flow/flow-box.vue";
    import FlowRelation from "@/components/flow/flow-relation.vue";
    import {FlowConfigVO} from "@/model/FlowConfigVO";
    import {
        checkFenqunFile,
        createFenqun,
        getFenqunContact,
        getFenqunDetail,
        getFenqunUploadLog,
        updateFenqunDetail
    } from "@/services/api";
    import {PageInfo} from "@/model/Resp";
    import {dateFormat, downloadFile2, timezoneChange} from "@/services/common";
    import {defaultTimezone} from "@/services/config";
import { getVueAppUploadApi } from "@/services/util";


    @Component({
        components: {
            'yc-aside': YcAside,
            'yc-header': YcHeader,
            'yc-flow-box': FlowBox,
            'yc-flow-relation': FlowRelation
        },
    })
    export default class UserGroupingUpload extends Vue {
        public subscribeStatusMap = {0: '未订阅', 1: '已订阅', 2: '取消订阅'}
        // 分群信息
        public fenqunDetail: TFenqunDetailVO = {};
        // 文件上传列表
        public fileList: {name: string, url?: string}[]= [];
        // 文件上传控制
        public uploadCtrl = true;
        // 创建用户群控制
        public createCtrl = false;
        // 文件解析错误信息
        public errorText = '';
        // 文件上传进度
        public percent: number = 0;
        // 配置项
        public config: FlowConfigVO | null = null;
        // 用户列表
        public userTable: TFenqunUserInfoVO[] = [];
        // 创建日志列表
        public recordTable: TFenqunRecordVO[] = [];
        // 上传地址
        public uploadUrl = getVueAppUploadApi() + "/upload/file";
        // 校验规则
        public rules = {
            name:[{ required: true, message: '请输入用户群名称', trigger: 'blur' }, {max: 200, message: '长度不能超过200个字符', trigger: 'blur' }],
        }
        // 上传文件展示控制
        public dialogVisible = false;
        // 页面分页信息
        public pageInfo: PageInfo = {
            currentPage: 1,
            pageSize: 20,
            total: 0
        }
        // 时区
        public timezone = localStorage.getItem("timezone") || defaultTimezone;

        timer:any = null

        creating = false;
        public bottom = '0px';
        async created(): Promise<void> {
            // console.log(localStorage.getItem('dns-needNotice'), 'xsxs')
            // localStorage.getItem('dns-needNotice') === 'true' && this.bottom = '50px';
            // 修复当它为true时会把下面的footer挤消失的问题
            if (localStorage.getItem('dns-needNotice') === 'true') {
                this.bottom = '50px'
            }
            const id = this.$route.params.id;
            if(id) {
                const dialogVisible = this.$route.query.dialogVisible?.toString();
                const fileName = this.$route.query.fileName?.toString();
                const fileUrl = this.$route.query.fileUrl?.toString();
                if (dialogVisible === 'true' && sessionStorage.getItem('show') === 'true') {
                    this.dialogVisible = true;
                    this.fileList = [{name: fileName, url: fileUrl}];
                    this.percent = 100;
                    this.createCtrl = true;
                    sessionStorage.setItem('show', 'false')
                }
                if(this.$route.params.id)
                await this.getFenqunDetail(parseInt(id));
            }
            await this.updateFenqunTable();

        }

        /**
         *获取用户群详情
         */
        async getFenqunDetail(id: number) {
            await getFenqunDetail({id}, true)
              .then(res => {
                  this.fenqunDetail = res.data.data;
              })
        }

        clickUploadLog(){
            this.dialogVisible = true
            this.getRecordTable()
        }

        updateFenqunDetail() {
            if (!this.fenqunDetail.id) {
                return;
            }
            const fenqunName: any = this.$refs.fenqunName;
            const nameEl: any = this.$refs.nameEl;
            let res = false;
            fenqunName.validate((valid: boolean) => {
                return (res = valid);
            });
            if (!res) {
                nameEl.focus();
                return;
            }
            if (this.creating) {
                return;
            }
            this.creating = true;
            updateFenqunDetail({fenqunId: this.fenqunDetail.id, name: this.fenqunDetail.name|| ''}, true).then((res) => {
                this.$message.success("保存成功");
                // this.$router.push("/user/grouping");
                window.location.href = '/cartsee-new/user/grouping'
                this.creating = false;
            }).catch(()=>{
                this.creating = false;
            });
        }

        /**
         * 取消
         */
        async cancel() {
            await this.$confirm(
              "确定放弃当前编辑吗？已配置内容将不再保存！",
              "确定放弃编辑吗？",
              {
                  customClass:'modalOk',
                  confirmButtonText: '放弃编辑',
                  cancelButtonText: '继续编辑'
              });
            // await this.$router.push('/user/grouping');
             window.location.href = '/cartsee-new/user/grouping'
        }

        /**
         * 获取token
         */
        get token() {
            return localStorage.getItem("token") || "default";
        }

        /**
         * 文件上传进度条
         */
        oProgressFnc(event: any, file: any, fileList: any): void {
            this.percent = event.percent;
        }

        /**
         * 文件上传前初始化
         */
        beforeUpload(file: any): boolean {
            if(!file.name.endsWith('.xlsx')) {
                this.$message.error('只支持xlsx文件');
                return false;
            }
            if(this.uploadCtrl) {
                this.errorText = '';
                this.createCtrl = false;
                this.uploadCtrl = false;
                this.fileList = [file];
                this.percent = 0;
                return true;
            } else {
                return false
            }
        }

        /**
         * 文件上传成功钩子函数
         */
        handleSuccess(
          res: { data: { fileName: string, url: string }[] }
        ): void {
            this.fileList = res.data.map(
              file =>({
                url: file.url,
                name: file.fileName
              })
            );
            // 单文件校验
            this.fileList?.[0]?.url
            && checkFenqunFile({url: this.fileList[0].url, name: this.getName(), fenqunId: this.fenqunDetail.id})
              .then(() => {
                  this.$message.success("文件上传成功！");
                  this.createCtrl = true;
                  this.createFenqun();
              })
              .catch(e => {
                  this.errorText = e.message || '';
              })
              .finally(() => {
                this.uploadCtrl = true;
              })
        }

        /**
         * 文件上传失败钩子函数
         */
        handleError(e: any): void {
            this.uploadCtrl = true;
            this.$message.warning("文件上传失败！");
            if (e.data && e.data.code === 401) {
                // 如果返回401 即没有权限，跳到登录页重新登录
                this.$alert("登录失效，请重新登录");
                // this.$router.replace({
                //     path: "/login",
                //     query: { redirect: this.$router.currentRoute.fullPath },
                // });
                window.location.href = '/cartsee-new/login?redirect='+ encodeURIComponent(this.$router.currentRoute.fullPath)
            }
        }

        /**
         * 创建用户群
         */
        async createFenqun () {
            const name = this.getName();
            if(!this.fenqunDetail.id) {
                const res = await createFenqun({
                    name: name,
                    url: this.fileList?.[0]?.url || '',
                }, true)
                // console.log(res)
                sessionStorage.setItem('show', 'true')
                await this.$router.replace(`/user/grouping/upload/${res.data.data.fenqunId}?dialogVisible=true&fileName=${this.fileList?.[0]?.name}&fileUrl=${this.fileList?.[0]?.url}`)
            } else {
                await createFenqun({
                    name: name,
                    url: this.fileList?.[0]?.url || '',
                    fenqunId: this.fenqunDetail.id
                }, true)
                await this.updateFenqunTable();
            }
        }

        /**
         * 获取用户群名称
         */
        getName(): string {
            return this.fenqunDetail?.name ||
              (
                (this.fileList?.[0]?.name || '')
                  .replace(/^.*\//, '')
                  .replace(/\.[^.]*$/, '')
                + ' '
                + dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
              );
        }
        /**
         * 分页大小变化
         * @param val
         */
        handleSizeChange(val: number): void {
            this.pageInfo.pageSize = val;
            this.pageInfo.currentPage = 1;
            this.getFenqunContact();
        }

        /**
         * 当前页面变化
         * @param val
         */
        handleCurrentChange(val: number): void {
            this.pageInfo.currentPage = val;
            this.getFenqunContact();
        }

        /**
         * 获取用户群用户
         */
        async getFenqunContact() {
          if (!this.fenqunDetail.id){
            return;
          }
          await getFenqunContact({
            currentPage: this.pageInfo.currentPage,
            pageSize:this.pageInfo.pageSize,
            fenqunId: this.fenqunDetail.id
          },true)
          .then(res => {
              this.userTable = res.data.data;
              this.userTable.map(contact => {
                  contact.firstActive = timezoneChange(contact.firstActive,'GMT+0800', this.timezone);
                  contact.lastActive = timezoneChange(contact.lastActive,'GMT+0800', this.timezone);
              })
              if (res.data.pageInfo) {
                  this.pageInfo = res.data.pageInfo;
              }
          })
        }

        /**
         * 更新用户群信息
         */
        async updateFenqunTable() {
            if (!this.fenqunDetail.id) {
                return;
            }
            await getFenqunUploadLog({fenqunId: this.fenqunDetail.id}, true)
            .then(res => {
                this.recordTable = res.data.data.map(item => {
                    item.failCount = item.sumCount - item.successCount;
                    return item;
                });
            }).catch(()=>{});

            this.pageInfo.currentPage = 1;
            await this.getFenqunContact();
        }

        async getRecordTable (){
            if ( !this.fenqunDetail.id) {
                return
            }
            await getFenqunUploadLog({fenqunId: this.fenqunDetail.id as number}, false)
                .then(res => {
                    this.recordTable = res.data.data.map(item => {
                        item.failCount = item.sumCount - item.successCount;
                        return item;
                    });
                }).catch(()=>{});
        }

        /**
         * 下载xlsx文件
         * @param url
         * @param name
         */
         downloadFile(url: string, name: string): void  {
            downloadFile2(url, name, 'xlsx');
        }

        @Watch('dialogVisible')
         dialogVisibleChange(val:boolean){
            if (val === true && this.$route.params.id) {
                this.timer = setInterval(() => {
                    this.getRecordTable()
                }, 1000 * 5);
            }else{
                this.updateFenqunTable()
                clearTimeout(this.timer)
            }

        }
    }
